import { useState } from 'react';
import logo from './logo.svg';

import QuestionInput from './components/QuestionInput/QuestionInput';
import QuestionAnswers from './components/QuestionAnswers/QuestionAnswers';
import PresetButtons from './components/PresetButtons/PresetButtons';

import './App.css';
import LoadingIcon from './components/LoadingIcon/LoadingIcon';

const ENDPOINT = window.TPAF_MIX_COACH_AI_ENDPOINT ?? 'https://test-wordpress.dev/wp-json/tpaf/v1/mix-coach-ai/get';
const PRESET_BUTTONS = window.TPAF_MIX_COACH_PRESET_BUTTONS ?? [];

function App() {

  const [questionPrompt, setQuestionPrompt] = useState('');
  const [promptAnswers, setPromptAnswers] = useState([]);
  const [footerContent, setFooterContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const generateBody = (x) => {
    return {
      data: {
        prompt: x
      }
    }
  }

  const sendRequest = async(x) => {
    setIsLoading(true);
    try {
      const data = await (await fetch(ENDPOINT, { method: "POST", body: JSON.stringify(generateBody(x))})).json()
      console.log(data);
      setPromptAnswers(promptAnswers => [...promptAnswers, data])

      if(data.footer_content) {
        setFooterContent(data.footer_content);
      }

    } catch(err) {
      console.log(err);
    }
    setIsLoading(false);
  }

  const prefillPrompt = (prompt) => {
    console.log(prompt)
    setQuestionPrompt(prompt)
  }

  return (
    <div className="App">
      <div className="App-header">
        <div className="main-title">
          <img src={logo} className="App-logo" alt="logo" />
          <p>PROAUDIOFILES AI</p>
        </div>
        <div className="sponsored-by">
          <span className="gray">SPONSORED BY </span>
          <span className="blue quiztones">QUIZTONES</span>
        </div>
      </div>
      <QuestionInput sendRequest={sendRequest} questionPrompt={questionPrompt} setQuestionPrompt={setQuestionPrompt}></QuestionInput>
      <PresetButtons presetButtons={PRESET_BUTTONS} buttonOnClick={prefillPrompt}></PresetButtons>
      <LoadingIcon isLoading={isLoading}></LoadingIcon>
      <QuestionAnswers answers={promptAnswers} footerContent={footerContent}></QuestionAnswers>
    </div>
  );
}

export default App;
